'use client'
import React from 'react'
import styles from './styles.module.scss'

const ModalTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.title}>{children}</div>
)

export default ModalTitle
